<template>
  <draggable ref="report">
    <div class="a-report" draggable="true" @dragend="onDragEnd">
      <div class="a-report__controls">
        <div class="a-report__tab-btn">
          {{$t('form.lot.mini-report.title')}}
        </div>
        <button class="a-report__remove" @click.prevent="$refs.report.hide()">
          <img src="@/assets/img/static/b-icon_close_mini.svg" alt="">
        </button>
      </div>
      <div class="table-tab table-tab--media460-responsible table-tab--th-row-none">
        <div class="table-tab__container" tabindex="2" style="overflow: hidden; outline: none; width: 800px">
          <table class="table-tab__block table">
            <thead class="table-tab__thead">
              <tr class="table-tab__tr">
                <th class=" table-tab__th--row table-tab__border-right">№</th>
                <th class="a-report__width-160px">{{$t('form.lot.mini-report.participant')}}</th>
                <th>{{$t('form.lot.mini-report.leader-in-positions')}}</th>
                <th>{{$t('form.lot.mini-report.total-price-over-best-positions')}}</th>
                <th>{{$t('form.lot.mini-report.total-present-price-over-best-positions')}}</th>
<!--                <th>Экономия</th>-->
              </tr>
            </thead>
            <tbody class="table-tab__tbody">
              <tr v-for="(item, itemId) in report">
                <th class="table-tab__th--row table-tab__border-right">
                  {{itemId + 1}}
                </th>
                <td>
                  {{item.request.organization}}
<!--                  Первый th<span class="table-tab__online">online</span>-->
                </td>
                <td>{{item.bestPositions.length}}</td>
                <td>{{item.cost | price}} {{$t(lot.currency.label)}}</td>
                <td>{{item.presentPrice | present-price}} {{$t(lot.currency.label)}}</td>
<!--                <td>8687</td>-->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </draggable>
</template>

<script>
  import _ from 'lodash'

  export default {
    props: {
      lot: {
        type: Object,
        required: true
      }
    },

    computed: {
      report() {
        const requests = this.lot.requests.filter(r => r.state.APPROVED || r.state.CONDITIONALLY_APPROVED);
        const summary = _.get(this.lot, 'requestsTotal.summary', []);
        const data = _.get(this.lot, 'requestsTotal.data', []);
        const orderedSummary = _.orderBy(summary, 'estimate', 'desc');
        const bestInPosition = _.values(orderedSummary.reduce((acc, e) => {
          let best = acc[e.position];

          if (!best) {
            acc[e.position] = e;
          }

          return acc;
        }, {}));


        const positions = requests.map(r => ({
          request: r,
          data: _.find(data, { request: r.num }),
          bestPositions: _.filter(bestInPosition, { requestId: r.num })
        }));

        const lotPriceCriteria = this.lot.criteria.lotPrice;
        const reductionCriteria = this.lot.criteria.reduction;

        _.each(positions, r => {
          const cost = r.bestPositions.reduce((acc, s) => {
            const items = r.data.criterions.filter(d => d.bid === s.bid && d.position === s.position && _.find(lotPriceCriteria, { num: d.num }));

            return acc + items.reduce((acc, e) => {
              const count = _.get(_.find(this.lot.specs, { position: s.position }), 'count') || 0;
              const price = +e.value || 0;

              return acc + count * price;
            }, 0);
          }, 0);

          const presentPrice = r.bestPositions.reduce((acc, s) => {
            const presentPrice = _.get(_.find(r.data.specs, { bid: s.bid, position: s.position }), 'presentPrice', 0);
            const count = _.get(_.find(this.lot.specs, { position: s.position }), 'count') || 0;

            return acc + presentPrice * count;
          }, 0);

          r.cost = cost;
          r.presentPrice = presentPrice;
        });

        return positions;
      }
    },

    methods: {
      show() {
        this.$refs.report.show();
      },

      onDragEnd(event) {
        this.$refs.report.move(event.offsetY, event.offsetX);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .a-report {
    .table-tab {
      background-color: white;
    }
  }
</style>
